// extracted by mini-css-extract-plugin
module.exports = {"container":"_bdd9014","active":"_ffab8d0","slide":"_48dc9b1"};